class AboutJs {
  constructor(el, opt) {
    this.el = el;
    this.valueImageSwiperInstance = false;
    this.valueTextSwiperInstance = false;
    if ($("." + this.el).length > 0) {
      this.event();
    }
    const aboutSwiper = document.querySelectorAll('.js-fade-swiper-divider');
    if (aboutSwiper.length > 0) {
      this.fadeSwiper(aboutSwiper);
    }
  }
  event() {

  }
  fadeSwiper(swiperEle) {
    swiperEle.forEach((item) => {
      new Swiper(item, {
        speed: 1500,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        autoplay: {
          delay: 3000
        }
      })
    })
  }
}
